import React from 'react';
import { useDecodedToken } from './authorization.hook';

import { View } from '@im/ui-lib/View';
import { RequireAuth } from './RequireAuth';

const ProfileViewComp = () => {
  const decodedToken = useDecodedToken();

  if (!decodedToken) {
    return (
      <div>
        <p>Fetching user profile...</p>
      </div>
    );
  }

  return (
    <View>
      <div>
        <h1>My User Profile (Access Token Claims)</h1>
        <p>
          Below is the information from your access token which was obtained
          during{' '}
          <a href="https://developer.okta.com/docs/guides/implement-auth-code-pkce">
            PKCE Flow
          </a>{' '}
          and is now stored in local storage.
        </p>
        <p>
          This View is protected with the <code>&lt;RequireAuth&gt;</code>{' '}
          component, which will ensure that this View cannot be accessed until
          you have authenticated.
        </p>
        <table>
          <thead>
            <tr>
              <td>
                <b>Claim</b>
              </td>
              <td>
                <b>Value</b>
              </td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(decodedToken).map((claimEntry) => {
              const claimName = claimEntry[0];
              const claimValue = claimEntry[1];
              const claimId = `claim-${claimName}`;
              return (
                <tr key={claimName}>
                  <td>{claimName}</td>
                  <td id={claimId}>
                    {typeof claimValue === 'object' ? (
                      <pre>{JSON.stringify(claimValue, undefined, 2)}</pre>
                    ) : (
                      claimValue.toString()
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </View>
  );
};

export const ProfileView = () => <RequireAuth children={<ProfileViewComp />} />;
